module.exports = __webpack_public_path__ + "599841d00703d81a3c68df9821f7ca98.png";